import { useToast } from "@/store/ToastContext";

const typeStyles: Record<string, string> = {
  success: "border-primary-300",
  error: "border-red-400",
  info: "border-secondary-300",
};

const typeIcons: Record<string, string> = {
  success: "ri-checkbox-circle-fill text-primary-500",
  error: "ri-error-warning-fill text-red-500",
  info: "ri-information-fill text-foreground-500",
};

export default function ToastContainer() {
  const { toasts, dismissToast } = useToast();

  return (
    <div className="fixed top-4 right-4 z-[60] flex flex-col gap-2 w-80 max-w-[calc(100vw-2rem)]">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-start gap-3 bg-background-50 border ${typeStyles[toast.type]} rounded-lg p-3 shadow-sm animate-fade-in-up`}
        >
          <span className="w-6 h-6 flex items-center justify-center shrink-0">
            <i className={`${typeIcons[toast.type]} text-xl`} />
          </span>
          <p className="flex-1 text-sm text-foreground-900">{toast.message}</p>
          <button
            onClick={() => dismissToast(toast.id)}
            className="w-6 h-6 flex items-center justify-center rounded-md hover:bg-secondary-100 text-foreground-500 cursor-pointer"
          >
            <i className="ri-close-line" />
          </button>
        </div>
      ))}
    </div>
  );
}